document.addEventListener('DOMContentLoaded', () => {
  const product = document.querySelector('.st-europe-product');
  if (!product) return;

  const gallery = product.querySelector('.st-product-gallery');
  const stage = gallery?.querySelector('.st-product-gallery__stage img');
  const dialog = gallery?.querySelector('.st-product-gallery__dialog');
  const dialogImage = dialog?.querySelector('img');
  const thumbs = Array.from(gallery?.querySelectorAll('[data-gallery-kind]') || []);
  const stageButton = gallery?.querySelector('.st-product-gallery__stage');
  const mobileMenu = document.getElementById('Details-menu-drawer-container');

  function syncMobileMenuState() {
    product.classList.toggle('st-mobile-menu-is-open', Boolean(mobileMenu?.open));
  }

  mobileMenu?.addEventListener('toggle', syncMobileMenuState);
  syncMobileMenuState();

  function showPhoto(button) {
    if (!button || !stage || !dialogImage) return;
    stage.src = button.dataset.gallerySrc;
    stage.alt = button.dataset.galleryAlt;
    dialogImage.src = button.dataset.gallerySrc;
    dialogImage.alt = button.dataset.galleryAlt;
    thumbs.forEach((thumb) => thumb.setAttribute('aria-pressed', String(thumb === button)));
  }

  thumbs.forEach((button) => button.addEventListener('click', () => showPhoto(button)));
  function showPhotoByDirection(direction) {
    if (!thumbs.length) return;
    const selectedIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.getAttribute('aria-pressed') === 'true'));
    showPhoto(thumbs[(selectedIndex + direction + thumbs.length) % thumbs.length]);
  }

  gallery?.querySelectorAll('[data-gallery-direction]').forEach((button) => {
    button.addEventListener('click', () => {
      showPhotoByDirection(Number(button.dataset.galleryDirection));
    });
  });

  let customTouchStart = null;
  let suppressCustomStageClick = false;
  stageButton?.addEventListener('touchstart', (event) => {
    const touch = event.touches[0];
    if (!touch) return;
    customTouchStart = { x: touch.clientX, y: touch.clientY };
  }, { passive: true });
  stageButton?.addEventListener('touchend', (event) => {
    if (!customTouchStart) return;
    const touch = event.changedTouches[0];
    const deltaX = touch ? touch.clientX - customTouchStart.x : 0;
    const deltaY = touch ? touch.clientY - customTouchStart.y : 0;
    customTouchStart = null;
    if (Math.abs(deltaX) < 42 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
    suppressCustomStageClick = true;
    showPhotoByDirection(deltaX < 0 ? 1 : -1);
    window.setTimeout(() => { suppressCustomStageClick = false; }, 350);
  }, { passive: true });
  stageButton?.addEventListener('click', (event) => {
    if (suppressCustomStageClick) {
      event.preventDefault();
      return;
    }
    dialog?.showModal();
  });
  dialog?.querySelector('.st-product-gallery__close')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  document.querySelectorAll('.st-europe-product media-gallery').forEach((nativeGallery) => {
    const viewport = nativeGallery.querySelector('[id^="Slider-Gallery-"]');
    const slides = Array.from(viewport?.querySelectorAll('[data-media-id]') || []);
    if (!viewport || slides.length < 2) return;

    let nativeTouchStart = null;
    let suppressNativeClick = false;

    function activeSlideIndex() {
      const currentTarget = nativeGallery.querySelector('[data-target] button[aria-current]')?.closest('[data-target]')?.dataset.target;
      const currentIndex = slides.findIndex((slide) => slide.dataset.mediaId === currentTarget);
      if (currentIndex >= 0) return currentIndex;
      const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      return activeIndex >= 0 ? activeIndex : 0;
    }

    viewport.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      if (!touch) return;
      nativeTouchStart = { x: touch.clientX, y: touch.clientY, index: activeSlideIndex() };
    }, { passive: true });

    viewport.addEventListener('touchend', (event) => {
      if (!nativeTouchStart) return;
      const touch = event.changedTouches[0];
      const deltaX = touch ? touch.clientX - nativeTouchStart.x : 0;
      const deltaY = touch ? touch.clientY - nativeTouchStart.y : 0;
      const startIndex = nativeTouchStart.index;
      nativeTouchStart = null;
      if (Math.abs(deltaX) < 42 || Math.abs(deltaX) <= Math.abs(deltaY)) return;

      const targetIndex = Math.max(0, Math.min(slides.length - 1, startIndex + (deltaX < 0 ? 1 : -1)));
      if (targetIndex === startIndex) return;
      suppressNativeClick = true;
      const target = slides[targetIndex];
      if (typeof nativeGallery.setActiveMedia === 'function') {
        nativeGallery.setActiveMedia(target.dataset.mediaId, false);
      } else {
        nativeGallery.querySelector(`[data-target="${target.dataset.mediaId}"] button`)?.click();
      }
      window.setTimeout(() => { suppressNativeClick = false; }, 350);
    }, { passive: true });

    viewport.addEventListener('click', (event) => {
      if (!suppressNativeClick) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  });

  const picker = product.querySelector('.st-offer-picker');
  if (!picker) return;
  const summaryName = product.querySelector('[data-selected-name]');
  const summaryPrice = product.querySelector('[data-selected-price]');
  const summaryCompare = product.querySelector('[data-selected-compare]');
  const stickyName = product.querySelector('[data-sticky-name]');
  const stickyPrice = product.querySelector('[data-sticky-price]');
  const addButton = product.querySelector('.product-form__submit');
  const addButtonText = addButton?.querySelector('span');

  function syncOffer(changePhoto = false) {
    const selected = picker.querySelector('.st-offer-input:checked');
    if (!selected) return;
    if (summaryName) summaryName.textContent = selected.dataset.offerName;
    if (summaryPrice) summaryPrice.textContent = selected.dataset.offerPrice;
    if (stickyName) stickyName.textContent = selected.dataset.offerName;
    if (stickyPrice) stickyPrice.textContent = selected.dataset.offerPrice;
    if (summaryCompare) {
      summaryCompare.textContent = selected.dataset.offerCompare || '';
      summaryCompare.hidden = !selected.dataset.offerCompare;
    }
    if (addButtonText && !addButton.disabled && addButtonText.textContent.trim() !== 'Add to cart') {
      addButtonText.textContent = 'Add to cart';
    }
    if (changePhoto) {
      const kind = selected.dataset.offerKind === 'set' ? 'set' : 'cards';
      showPhoto(thumbs.find((thumb) => thumb.dataset.galleryKind === kind));
    }
  }

  picker.addEventListener('change', () => syncOffer(true));
  const sticky = product.querySelector('.st-sticky-buy');
  const buyPanel = product.querySelector('.st-buy-panel-tail');
  if (sticky && buyPanel && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
    }).observe(buyPanel);
  }
  if (addButtonText) {
    new MutationObserver(() => syncOffer()).observe(addButtonText, { childList: true, characterData: true, subtree: true });
  }
  syncOffer();

  if (new URLSearchParams(window.location.search).has('variant')) return;
  const setInput = picker.querySelector('.st-offer-input[data-offer-kind="set"]');
  if (!setInput || setInput.checked || setInput.disabled) return;
  setInput.checked = true;
  setInput.dispatchEvent(new Event('change', { bubbles: true }));
});
